import React, { useState } from 'react';

const CompanyRoleStep = ({ data, updateData, onNext, onPrevious, isValid, isFirstStep }) => {
  const [currentRoleInput, setCurrentRoleInput] = useState(data.currentRole || '');
  const [companyNameInput, setCompanyNameInput] = useState(data.companyName || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid) {
      onNext();
    }
  };

  const handleRoleChange = (e) => {
    const value = e.target.value;
    setCurrentRoleInput(value);
    updateData('currentRole', value);
  };

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setCompanyNameInput(value);
    updateData('companyName', value);
    // Clear companyId since this is freeform input
    updateData('companyId', null);
  };

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="space-y-8 md:space-y-12">
        {/* Question */}
        <div className="text-center space-y-4">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white leading-tight">
            What is your current role & company?
          </h1>
          <p className="text-lg md:text-xl text-gray-600 dark:text-gray-400">
            Help us understand your professional background
          </p>
        </div>

        {/* Enhanced Inputs with Animations */}
        <div className="space-y-8">
          {/* Current Role Input */}
          <div className="space-y-3">
            <label className="block text-lg font-medium text-gray-700 dark:text-gray-300 transition-colors duration-300">
              Current Role
            </label>
            <div className="relative overflow-hidden pb-1">
              <input
                type="text"
                value={currentRoleInput}
                onChange={handleRoleChange}
                placeholder="e.g., Software Engineer, Product Manager"
                className="w-full px-6 py-4 text-xl bg-transparent border-0 border-b-2 border-gray-300 dark:border-gray-600 
                         focus:outline-none focus:border-purple-500 dark:focus:border-purple-400
                         dark:text-white dark:placeholder-gray-500 placeholder-gray-400
                         transition-all duration-300 ease-in-out
                         hover:border-purple-300 dark:hover:border-purple-500
                         focus:scale-105 focus:shadow-lg focus:shadow-purple-500/10"
                required
              />
              {/* Animated underline */}
              <div className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-purple-500 to-indigo-500 transition-all duration-300 ${
                currentRoleInput ? 'w-full opacity-100' : 'w-0 opacity-0'
              }`}></div>
            </div>
          </div>

          {/* Company Input */}
          <div className="space-y-3">
            <label className="block text-lg font-medium text-gray-700 dark:text-gray-300 transition-colors duration-300">
              Company
            </label>
            <div className="relative overflow-hidden pb-1">
              <input
                type="text"
                value={companyNameInput}
                onChange={handleCompanyChange}
                placeholder="e.g., Google, Microsoft, Startup Inc."
                className="w-full px-6 py-4 text-xl bg-transparent border-0 border-b-2 border-gray-300 dark:border-gray-600 
                         focus:outline-none focus:border-purple-500 dark:focus:border-purple-400
                         dark:text-white dark:placeholder-gray-500 placeholder-gray-400
                         transition-all duration-300 ease-in-out
                         hover:border-purple-300 dark:hover:border-purple-500
                         focus:scale-105 focus:shadow-lg focus:shadow-purple-500/10"
                required
              />
              {/* Animated underline */}
              <div className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-purple-500 to-indigo-500 transition-all duration-300 ${
                companyNameInput ? 'w-full opacity-100' : 'w-0 opacity-0'
              }`}></div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Enhanced Navigation Buttons */}
      <div className="flex justify-between items-center mt-8 border-none !border-0">
        {!isFirstStep && (
          <button
            type="button"
            onClick={onPrevious}
            className="px-6 py-3 rounded-lg text-lg font-medium text-gray-600 dark:text-gray-400 
                     hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-100 
                     dark:hover:bg-gray-700 transition-all duration-300 ease-in-out
                     transform hover:scale-105 active:scale-95 focus:ring-4 focus:ring-gray-500/20"
          >
            Back
          </button>
        )}
        
        <button
          type="button"
          onClick={handleSubmit}
          disabled={!isValid}
          className={`px-8 py-4 rounded-lg text-lg font-medium transition-all duration-300 ease-in-out transform ${
            isValid
              ? 'bg-purple-600 hover:bg-purple-700 text-white shadow-lg hover:shadow-xl hover:shadow-purple-500/25 hover:scale-105 active:scale-95 focus:ring-4 focus:ring-purple-500/20'
              : 'bg-gray-300 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed opacity-60'
          } ${isFirstStep ? 'ml-auto' : ''}`}
        >
          <span className="flex items-center">
            Continue
            <span className={`ml-2 transition-transform duration-300 ${isValid ? 'translate-x-0' : ''}`}>
              →
            </span>
          </span>
        </button>
      </div>
    </div>
  );
};

export default CompanyRoleStep; 